import { GeoJSON, GML, GPX, KML, TopoJSON } from 'ol/format'
import { Vector as VectorLayer } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import { Circle, Fill, Stroke, Style } from 'ol/style'

import { SHP } from './map/shp'
import { getLayerIndex, map } from './map/tools'
import { showMessageBox } from './notifications'

export let gpsSource;

const getExtention = (file) => file.name.split('.').pop().toLowerCase();

const getFileType = (file) => {
  // file.type for sosi in chrome gives empty string
  const ext2type = {
    gml: 'application/gml+xml',
    geojson: 'application/geo+json',
    gpx: 'application/gpx+xml',
    json: 'application/json',
    kml: 'application/vnd.google-earth.kml+xml',
    sos: 'text/vnd.sosi',
    topojson: 'application/topo+json',
// beware that Windows uploads .zip with MIME type application/x-zip-compressed
    zip: 'application/zip'
  };
  return file.type || ext2type[getExtention(file)];
};

const getOlFormat = (file, text) => {
  const type = getFileType(file);
  const format = {
    // 'text/vnd.sosi': new sosiFormat(), // defined in klimagasskalkulator_gui
    'application/gpx+xml': new GPX(),
    'application/gml+xml': new GML(),
    'application/vnd.google-earth.kml+xml': new KML(),
    'application/json': new GeoJSON(),
    'application/geo+json': new GeoJSON(),
    'application/topo+json': new TopoJSON(),
    'application/x-zip-compressed': new SHP({}),
    'application/zip': new SHP({})
  };
  return format[type];
};

export const loadGpsFeatures = (f, filename) => {
  // console.log('loadGpsFeatures', filename);
  gpsSource = new VectorSource({ features: f });
  const gpsLayer = new VectorLayer({
    id: filename,
    style: gpsStyleFunction,
    source: gpsSource,
    zIndex: 2
  })
  // map.addLayer(gpsLayer);
  // Insert gpsLayer before drawings:
  map.getLayers().insertAt(getLayerIndex('vectorLayer') + 1, gpsLayer);
  addtoGpsList(gpsLayer);
  map.getView().fit(gpsSource.getExtent());
  showMessageBox('gpsMessage');
};

export const uploadFile = (f) => {
  // console.log(f.name, f.type);
  const zip = f.type.indexOf('zip') > -1;
  const reader = new FileReader();
  if (!zip) reader.readAsText(f, 'UTF-8'); else reader.readAsArrayBuffer(f);
  // When the file is read, it triggers the onload event:
  reader.onload = () => {
    const text = reader.result;
    const features = getOlFormat(f, text).readFeatures(text, {
      featureProjection: map.getView().getProjection().getCode()
    });
    loadGpsFeatures(features, f.name);
  };
};

const gpsLineStyle = new Style({
  stroke: new Stroke({ color: 'hotpink', lineDash: [12, 10], width: 3 })
});

const gpsStyle = {
  Point: new Style({
    image: new Circle({
      fill: new Fill({
        color: 'rgba(255, 255, 0, 0.5)'
      }),
      radius: 5,
      stroke: new Stroke({
        color: 'yellow',
        width: 1
      })
    })
  }),
  LineString: gpsLineStyle,
  Polygon: new Style({
    fill: new Fill({
      color: 'rgba(0, 255, 255, 0.3)'
    }),
    stroke: new Stroke({
      color: 'aqua',
      width: 1
    })
  }),
  MultiPoint: new Style({
    image: new Circle({
      fill: new Fill({
        color: 'rgba(255, 0, 255, 0.5)'
      }),
      radius: 5,
      stroke: new Stroke({
        color: 'fuchsia',
        width: 1
      })
    })
  }),
  MultiLineString: gpsLineStyle,
  MultiPolygon: new Style({
    fill: new Fill({
      color: 'rgba(0, 0, 255, 0.5)'
    }),
    stroke: new Stroke({
      color: 'blue',
      width: 1
    })
  })
};

const gpsStyleFunction = function(feature, resolution) {
  // console.log(feature.getGeometry().getType());
  const featureStyleFunction = feature.getStyleFunction();
  if (featureStyleFunction) {
    return featureStyleFunction.call(feature, resolution);
  } else {
    return gpsStyle[feature.getGeometry().getType()];
  }
};

const addtoGpsList = (gps) => {
  const list = document.getElementById('gpsList');
  const filename = gps.get('id');
  // console.log(list.childElementCount);
  const bold = document.createElement('b');
  bold.innerHTML = filename; //.slice(0, -4);
  // span.style.maxWidth = 'calc(100% - 40px)';
  const li = document.createElement('li');
  li.className = 'gps-item';
  li.appendChild(bold);
  const x = document.createElement('button');
  x.onclick = () => { map.removeLayer(gps); list.removeChild(li); };
  x.className = 'bin-btn red-transition';
  x.setAttribute('ariaLabel', 'Fjern');
  x.title = 'Fjern GPS-spor';
  // x.innerHTML = '<span aria-hidden="true">&times;</span>';
  x.innerHTML = '<i class="material-icons">delete_forever</i>';

  li.appendChild(x);
  list.appendChild(li);
  const originalStyle = gps.getStyle();
  li.onmouseenter = () => {
    // console.log('highlight feature on map', gps.getStyle());
    gps.setStyle(new Style({
      fill: new Fill({ color: 'rgba(255, 0, 0, 0.4)' }),
      stroke: new Stroke({ color: 'hotpink', width: 6 })
    }));
  };
  li.onmouseleave = () => gps.setStyle(originalStyle);
  li.onclick = () => map.getView().fit(gps.getSource().getExtent());
};
